import React, { useEffect, useState } from "react";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import closeIcon from "../../../../assets/closeModel.png";
import checkedIcon from "../../../../assets/check-mark.png";
import deleteIcon from "../../../../assets/trash.png";

import {
  Alert,
  DialogContent,
  DialogContentText,
  Tab,
  Tabs,
} from "@mui/material";

import CompanyInfoForm from "./CompanyInfoForm";
// import SubscriptionPlanForm from "./SubscriptionPlanForm";
import FinancialInfoForm from "./FinancialInfoForm";
import EmailSettingForm from "./EmailSettingForm";

import Validation from "../../../../utils/Validation";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  addTelnetAction,
  initialClientLocalState,
  putEditClientAction,
  resetNewClientLocal,
  setAddTelnetAction,
  setEditClientAction,
  setNewClientLocal,
} from "../../../../store/reducers/adminClientsSlice";
import { companyInfoFields } from "./clientAllFields";
import { useToasts } from "react-toast-notifications";
import Notification from "../../../../components/common/notification/Notification";
// import ResetFormAlert from "./ResetFormAlert";
import {
  setNotificationAction,
  setUploadFileAction,
} from "../../../../store/reducers/mmymSlice";
import ResetFormAlert from "./ResetFormAlert";
import { getUserProfile } from "../../../../store/reducers/userSlice";

const clientFormField: any = [
  companyInfoFields.find((field) => field?.id === "clientName"),
];

interface clientDetail {
  name: string | null;
  email: string | null;
  role: string | null;
  contactNumber: string | null;
  socialNumber: string | null;
  status: string[] | null;
  permission: string[] | null;
  uploadedImage: string | null;
}

interface ManageTenantProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectClient: any; // Adjust type as per your requirement
  action?: any;
}

export default function ManageTenant(props: ManageTenantProps) {
  const [formData, setFormData]: any = React.useState({});
  const [imageError, setImageError] = useState(false);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [countryCode, setCountryCode] = useState<string>("+44"); // State for country code
  const [isImageReset, setIsImageReset] = useState(false);
  // State for radio button selection (Yes/No for Reg No)
  const [isRegNo, setIsRegNo] = useState(false);
  const dispatch = useDispatch();
  const {
    newClientLocal,
    isUniqueCompanyNameError,
    isUniqueVatError,
    isAddClientSuccess,
    isClientEditSuccess,
    editClientOriginalData,
  } = useSelector((state: any) => state?.adminClients);

  const validationData: any = {
    clientName: newClientLocal?.companyProfile?.clientName || "",
    companyName: newClientLocal?.companyProfile?.companyName || "",
    phoneNumber:
      newClientLocal?.companyProfile?.phoneNumber.replace(/^(\+91|\+44)/, "") ||
      "",
    address: newClientLocal?.companyProfile?.address || "",
    // vatPercent: (isRegNo==='yes' || isRegNo) ? newClientLocal?.companyProfile?.vatPercent : "",
    // vatRegNo: (isRegNo==='yes' || isRegNo) ? newClientLocal?.companyProfile?.vatRegNo : "",
    dateFormat: newClientLocal?.companyProfile?.dateFormat || "",
    postCode: newClientLocal?.companyProfile?.postCode || "",
    transportCode: newClientLocal?.companyProfile?.transportCode || "",
    generalWebsite: newClientLocal?.companyProfile?.generalWebsite || "",
    // invoiceAddress: newClientLocal?.financialInformation?.invoiceAddress || "",
    // paymentTerms: newClientLocal?.financialInformation?.paymentTerms || "",
    extendedLiabilityPercent:
      newClientLocal?.financialInformation?.extendedLiabilityPercent || "",
    extendedLiabilityTax:
      newClientLocal?.financialInformation?.extendedLiabilityTax || "",
    insuranceFixedRate:
      newClientLocal?.financialInformation?.insuranceFixedRate || "",
    email: newClientLocal?.emailSetting?.email || "",
    notificationEmail: newClientLocal?.emailSetting?.notificationEmail || "",
    accountsEmail: newClientLocal?.companyProfile?.accountsEmail || "",
    // Conditionally adding `vatPercent` and `vatRegNo`
    ...(isRegNo
      ? {
          vatPercent: newClientLocal?.companyProfile?.vatPercent || "",
          vatRegNo: newClientLocal?.companyProfile?.vatRegNo || "",
        }
      : ""),
  };

  const [
    companyProfileError,
    companyProfileCheckValidator,
    companyProfileResetValidator,
    companyProfileResetAllValidator,
    companyProfileIsError,
    isErrorOptional,
  ]: any = Validation(validationData);

  useEffect(() => {
    companyProfileResetValidator("vatRegNo");
    companyProfileResetValidator("vatPercent");
    companyProfileResetAllValidator();
  }, [isRegNo]);

  useEffect(() => {
    if (newClientLocal && newClientLocal.companyProfile?.phoneNumber) {
      const phone = newClientLocal.companyProfile.phoneNumber;
      // Check if phone number starts with "+" before matching
      if (phone.startsWith("+")) {
        const extractedCountryCode =
          newClientLocal.companyProfile?.phoneNumber?.match(/^\+91|\+44/);
        setCountryCode(extractedCountryCode ? extractedCountryCode[0] : "+44");
      }
    }
  }, [newClientLocal]);

  useEffect(() => {
    if (newClientLocal && newClientLocal.companyProfile?.vatRegNo) {
      setIsRegNo(true);
    } else {
      setIsRegNo(false);
    }
  }, [newClientLocal]);

  useEffect(() => {
    if (isAddClientSuccess || isClientEditSuccess) {
      dispatch(setAddTelnetAction(false));
      dispatch(getUserProfile());
      dispatch(setEditClientAction(false));
      dispatch(resetNewClientLocal());
      props.onHide();
      setImageError(false);
    }
  }, [isAddClientSuccess, isClientEditSuccess]);

  React.useEffect(() => {
    const fields: any = {};
    clientFormField.map((field: any) => {
      fields[field?.id] = "";
      return true;
    });
    setFormData(fields);
  }, []);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (props?.action !== "plan") {
      companyProfileCheckValidator();
    }
    setTimeout(() => {
      setIsActionCalled(true);
    }, 200);
  };

  useEffect(() => {
    if (isActionCalled) {
      // Create the updated phone number with country code
      const updatedPhoneNumber = newClientLocal?.companyProfile?.phoneNumber
        ? `${countryCode}${newClientLocal?.companyProfile?.phoneNumber.replace(
            /^(\+91|\+44)/,
            ""
          )}`
        : "";

      // Update the local `newClientLocal` object with the updated phone number
      const updatedClientData = {
        ...newClientLocal,
        companyProfile: {
          ...newClientLocal?.companyProfile,
          phoneNumber: newClientLocal?.companyProfile?.phoneNumber.replace(
            /^(\+91|\+44)/,
            ""
          )
            ? updatedPhoneNumber
            : "", // Ensure phone number includes country code
        },
      };

      // Update the Redux store with the updated client data
      dispatch(setNewClientLocal(updatedClientData));

      if (props?.action === "plan") {
        dispatch(addTelnetAction(updatedClientData));
      } else {
        if (
          !companyProfileIsError() &&
          !isErrorOptional() &&
          companyProfileError !== null &&
          isActionCalled
        ) {
          setIsActionCalled(false);

          if (props?.action === "edit") {
            dispatch(putEditClientAction(updatedClientData));
          } else {
            dispatch(addTelnetAction(updatedClientData));
          }
        } else {
          console.log("companyProfileError", companyProfileError);
          setIsActionCalled(false);
          // companyProfileCheckValidator();
        }
      }
    }
  }, [isActionCalled]);

  const { selectClient, onHide, open, title } = props;
  const [clientDetail, setClientDetail] = useState<clientDetail>({
    name: null,
    email: null,
    role: null,
    contactNumber: null,
    socialNumber: null,
    status: null,
    permission: null,
    uploadedImage: null,
  });

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("sm"); // Adjust the type definition
  const classes = useStyles();
  const handleImageUpload = (image: string | null) => {
    console.log("Uploaded image:", image);
    setClientDetail((prevDetail) => ({ ...prevDetail, uploadedImage: image }));
    if (image) {
      setImageError(false);
    }
  };

  const [stepActive, setStepActive] = useState(
    props?.action === "plan" ? 3 : 0
  );

  const hideHandler = () => {
    // if (stepActive === 0) {
    dispatch(resetNewClientLocal());
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    props.onHide();
    setImageError(false);
    dispatch(
      setUploadFileAction({
        url: "",
        key: "",
      })
    );
    // } else {
    //   setStepActive(0);
    // }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setStepActive(newValue);
  };

  const [alerModeShow, setAlertModelShow] = useState(false);

  const handleClear = () => {
    setAlertModelShow(true);
    setFormData(initialClientLocalState);
    // dispatch(resetNewClientLocal());
  };

  const handleTabError = (tab: any) => {
    if (tab === 1) {
      if (
        companyProfileError?.clientName ||
        companyProfileError?.companyName ||
        // companyProfileError?.phoneNumber ||
        companyProfileError?.address ||
        companyProfileError?.vatPercent ||
        companyProfileError?.vatRegNo ||
        companyProfileError?.dateFormat ||
        companyProfileError?.postCode ||
        companyProfileError?.transportCode ||
        companyProfileError?.generalWebsite ||
        isUniqueCompanyNameError ||
        isUniqueVatError
      ) {
        return true;
      } else {
        return false;
      }
    }
    // if (tab === 2) {
    //   if (
    //     companyProfileError?.invoiceAddress ||
    //     companyProfileError?.paymentTerms ||
    //     companyProfileError?.extendedLiabilityPercent ||
    //     companyProfileError?.extendedLiabilityTax ||
    //     companyProfileError?.insuranceFixedRate
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }
    if (tab === 3) {
      if (
        companyProfileError?.email ||
        companyProfileError?.notificationEmail ||
        companyProfileError?.accountsEmail
        // companyProfileError?.emailPassword ||
        // companyProfileError?.emailSignature ||
        // companyProfileError?.emailDisclaimer
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  useEffect(() => {
    if (isImageReset) {
      dispatch(
        setUploadFileAction({
          url: "",
          key: "",
        })
      );
      setIsImageReset(false);
    }
  }, [isImageReset]);

  return (
    <>
      <Popup
        open={open} // Example value, replace with your actual state or variable
        title={props?.action === "plan" ? "Update Plan" : title} // Example title, replace with your actual title
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        aria-describedby="alert-dialog-slide-description"
        popupBg="#fff"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              alt="save"
            />
            <img
              onClick={handleClear}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent sx={{padding:'10px'}}>
          <DialogContentText>
            <>
              {!editClientOriginalData?.transport_code && (
                <Alert severity="warning" style={{ marginBottom: "10px" }}>
                  You'll need to add the details in order to proceed.{" "}
                  {editClientOriginalData?.transport_code}
                </Alert>
              )}
              <Notification />
              <Tabs
                className={`tab-root ${
                  (
                    handleTabError(1) && stepActive === 0
                      ? "tab-error"
                      : handleTabError(2) && stepActive === 1
                      ? "tab-error"
                      : handleTabError(3) && stepActive === 2
                  )
                    ? "tab-error"
                    : ""
                }`}
                style={{ fontSize: "12px", fontWeight: 600,border:'1px solid #E5F4F1',background:'#E5F4F1' }}
                value={stepActive}
                onChange={handleChange}
                variant="fullWidth"
                // indicatorColor="secondary"
                aria-label="visible arrows tabs example"
                sx={{
                  "& .MuiTab-root": {
                    fontSize: "13px", // Tab font size
                    fontWeight: 600,
                    backgroundColor: "#f5f5f5", // Tab background color
                  },
                  "& .Mui-selected": {
                    backgroundColor: "#e0e0e0", // Selected tab background color
                  },
                }}
              >
                <Tab
                  label="Company Info"
                  className={handleTabError(1) ? "tab-error" : ""}
                  disabled={
                    props?.action === "plan"
                      ? true
                      : props?.action !== "edit" && newClientLocal?.tenantId
                      ? true
                      : false
                  }
                />
                {/* <Tab
                  label="Financial Info"
                  className={handleTabError(2) ? "tab-error" : ""}
                  disabled={
                    props?.action === "plan"
                      ? true
                      : (props?.action !== "edit" &&
                          newClientLocal?.tenantId) ||
                        isUniqueCompanyNameError ||
                        isUniqueVatError
                      ? true
                      : false
                  }
                /> */}
                <Tab
                  label="Email Settings"
                  className={handleTabError(3) ? "tab-error" : ""}
                  disabled={
                    (
                      props?.action === "plan"
                        ? true
                        : (props?.action !== "edit" &&
                            newClientLocal?.tenantId) ||
                          isUniqueCompanyNameError ||
                          isUniqueVatError
                    )
                      ? true
                      : false
                  }
                />
                {/* <Tab
                  label="Subscription"
                  disabled={
                    (
                      props?.action === "edit"
                        ? true
                        : isUniqueCompanyNameError || isUniqueVatError
                    )
                      ? true
                      : false
                  }
                /> */}
              </Tabs>
            </>
            <>
              {stepActive === 0 && (
                <CompanyInfoForm
                  selectClient={""}
                  companyProfileError={companyProfileError}
                  formData={formData}
                  setFormData={setFormData}
                  resetValidator={companyProfileResetValidator}
                  checkValidator={companyProfileCheckValidator}
                  action={props?.action}
                  isImageReset={isImageReset}
                  setCountryCode={setCountryCode}
                  countryCode={countryCode}
                  isRegNo={isRegNo}
                  setIsRegNo={setIsRegNo}
                />
              )}
            </>

            <>
              {/* {stepActive === 1 && (
                <div style={{ margin: "40px 0px" }}>
                  <FinancialInfoForm
                    selectClient={""}
                    finanicalError={companyProfileError}
                    formData={formData}
                    setFormData={setFormData}
                    resetValidator={companyProfileResetValidator}
                    checkValidator={companyProfileCheckValidator}
                  />
                </div>
              )} */}
            </>
            <>
              {stepActive === 1 && (
                <div style={{ marginTop: "40px", minHeight: "390px" }}>
                  <EmailSettingForm
                    selectClient={""}
                    emailSettingError={companyProfileError}
                    formData={formData}
                    setFormData={setFormData}
                    checkValidator={companyProfileCheckValidator}
                    companyProfileIsError={companyProfileIsError}
                    action={props?.action}
                  />
                </div>
              )}
            </>
            <>
              {stepActive === 3 && (
                <div style={{ marginTop: "40px", minHeight: "390px" }}>
                  {/* <SubscriptionPlanForm
                    selectClient={""}
                    formData={formData}
                    setFormData={setFormData}
                    action={props?.action}
                  /> */}
                </div>
              )}
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <>
          <ResetFormAlert
            open={alerModeShow}
            title=""
            alertModalShow={alerModeShow}
            setAlertModelShow={setAlertModelShow}
            setFormData={setFormData}
            companyProfileResetAllValidator={companyProfileResetAllValidator}
            action={props?.action}
            setIsImageReset={setIsImageReset}
          />
        </>
      )}
    </>
  );
}
